module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-search-view"
  }, [_c('div', {
    staticClass: "sd-scrollable-div"
  }, [_c('div', {
    staticClass: "sd-anchor-top"
  }), _vm._v(" "), _c('filters'), _vm._v(" "), (_vm.isResults) ? _c('div', {
    staticClass: "sd-add-div"
  }, [_c('a', {
    attrs: {
      "href": _vm.mailAddress
    }
  }, [_vm._v("\n        Ein neues Ticket erstellen\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-pagi-wrapper"
  }, [(_vm.isResults) ? _c('search-pagination', {
    attrs: {
      "routeKey": _vm.routeKey,
      "jiraTotal": _vm.jiraTotal,
      "confluencePreviousReq": _vm.confluencePreviousReq,
      "confluenceNextReq": _vm.confluenceNextReq,
      "textSearch": _vm.searchValue,
      "maxResults": _vm.maxResults
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.displayCards) ? _c('div', [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.isResults) ? _c('div', {
    key: _vm.currentPage,
    staticClass: "sd-results-div",
    class: {
      loading: _vm.loader
    }
  }, [(_vm.confluenceResults.length &&
    _vm.currentPage <= _vm.confluencePageIncrement) ? _c('confluence-card', {
    attrs: {
      "confluenceResults": _vm.confluenceResults,
      "routeKey": _vm.routeKey
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jiraResults.length &&
    _vm.currentPage <= _vm.jiraIncrementPage) ? _c('jira-card', {
    attrs: {
      "displayMethod": 'text-search-list',
      "baseUrl": _vm.baseUrl,
      "mailAddress": _vm.mailAddress,
      "routeKey": _vm.routeKey,
      "preloadedResult": false,
      "preloadedComments": false,
      "jiraResults": _vm.jiraResults
    }
  }) : _vm._e()], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.displayList) ? _c('div', [(_vm.jiraResults) ? _c('div', {
    key: _vm.currentPage,
    staticClass: "sd-results-div"
  }, [(_vm.jiraResults.length) ? _c('list-view', {
    attrs: {
      "loader": _vm.loader,
      "results": _vm.jiraResults
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('loader-animation', {
    attrs: {
      "loader": _vm.loader,
      "isResults": _vm.isResults,
      "errorMessage": null
    }
  })], 1), _vm._v(" "), (_vm.isResults) ? _c('arrow-top') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53158b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/SearchView.vue
// module id = 431
// module chunks = 1